module.exports = __webpack_public_path__ + "static/media/configuration-favorite-cta.b9837505.png";